define('views/modules/setting/business/modals/payment-delete-method-modal',[
    // Libs
    'underscore',
    'backbone',
    'mustache',
    'debug',
    'utils',
    'toastr',
    // services
    'services/i18n',
    'services/api',
    'services/session',
    // views
    'views/parts/modal/modal',
    // templates
    'text!templates/modules/setting/business/modals/payment-delete-method-modal.html',

], function(
    // Libs
    _, Backbone, Mustache, DEBUG, U, Toastr,
    // sessions
    i18n,
    API,
    Session,
    // views
    VModal,
    //templates
    TPaymentDeleteMethodModal
) {
    var VPaymentDeleteMethodModal = VModal.extend({
        template: TPaymentDeleteMethodModal,

        modal: function() {
            return {
                closeButton: false,
                titlmere: i18n.t("payment:deleting_payment_method_title"),
                size: 'small',
                buttons: {
                },
            };
        },

        initialize: function(opt) {
            this.options = _.extend({}, opt);
        },

        render: function() {
            var html = Mustache.render(this.template, Mustache.getContext());

            this.$el.empty().append(html);
            this.generateZones();

            this.renderModal();

            this.deletePaymentMethod();

            return this;
        },

        deletePaymentMethod: function() {
            var url = API.url("payments/team/" + this.options.teamPaymentModel.get('payment').id);

            return Backbone.ajax(
                _.extend({
                    url: url,
                    method: "DELETE",
                    dataType: "json",
                    contentType: "application/json",
                    context: this,
                }, {
                    
                    error: function(jqXHR, textStatus, errorThrown) {
                        Toastr.error(
                            i18n.t("payment:deleting_payment_method_error_message"),
                            i18n.t("payment:deleting_payment_method_error_title"), {
                                positionClass: "toast-top-center",
                                newestOnTop: false,
                                showMethod: "slideDown",
                                tapToDismiss: false,
                                closeButton: true
                            }
                        );

                        this.close();
                    },
                    success: function(response, textStatus, jqXHR) {
                        this.options.teamPaymentModel.deletePayment();

                        Toastr.success(
                            i18n.t("payment:deleting_payment_method_success_message"),
                            i18n.t("payment:deleting_payment_method_success_title"), {
                                positionClass: "toast-top-center",
                                newestOnTop: false,
                                showMethod: "slideDown",
                                tapToDismiss: false,
                                closeButton: true
                            }
                        );

                        this.close();
                    },

                })
            );

        },

        show: function(model) {
            this.render();
        },
    });

    return VPaymentDeleteMethodModal;
});

